import React from 'react'

const ThankYouScreen = () => {
  return (
    <div className="bg-mainTheme min-h-screen h-full overflow-hidden">
        <div className="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8 flex flex-col">
            <h1 className='text-7xl sm:text-9xl font-extrabold tracking-tight text-white mb-4 text-center'>
                THANK YOU!
            </h1>
            <h3 className='text-2xl font-extrabold tracking-tight text-white mb-32 text-center'>Stay dry.</h3>
            <div className='mt-auto grid place-items-center'>
              <a href='/'>
                <img src={require('../images/AhrainLogoNewWhite.png')} className='hover:-translate-y-3 hover:scale-125 w-44 h-auto text-center justify-center'/>
              </a>
            </div>
        </div>

     </div>
  )
}

export default ThankYouScreen